export default "__VITE_ASSET__55051f5c__"